import { IS_PRIVATE } from '@/config';

export enum ESidebarTab {
  SUMMARY = 'summary',
  AIQA = 'aiqa',
}

export const SIDEBAR_TABS = [
  {
    key: ESidebarTab.SUMMARY,
    label: '总结',
    disabled: false,
    serial: 0,
  },
  {
    key: ESidebarTab.AIQA,
    label: '问答',
    disabled: IS_PRIVATE,
    serial: 1,
  },
];

export const wsUrl = IS_PRIVATE ?
  `ws://${import.meta.env.VITE_LIVE_GATEWAY_WS_HOST || location.host}/${import.meta.env.VITE_LIVE_GATEWAY_WS_URL}/sync` :
  `${import.meta.env.VITE_LIVE_GATEWAY_WS_URL}/sync`;